import { render, staticRenderFns } from "./IcoCalendarClock.vue?vue&type=template&id=2eaecf8b"
import script from "./IcoCalendarClock.vue?vue&type=script&lang=js"
export * from "./IcoCalendarClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports